export default {
  name: "Menu",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M3 6a1 1 0 0 1 1-1h24c.55 0 1 .45 1 1s-.45 1-1 1H4a1 1 0 0 1-1-1zm25 9H4c-.55 0-1 .45-1 1s.45 1 1 1h24c.55 0 1-.45 1-1s-.45-1-1-1zm0 10H4c-.55 0-1 .45-1 1s.45 1 1 1h24c.55 0 1-.45 1-1s-.45-1-1-1z",
  },
}
